import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  UrlTree,
} from '@angular/router';
import { AuthStore } from '../stores/auth.store';

export const privilegeGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
): boolean | UrlTree => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  const expectedPrivileges = (route.data['expectedPrivileges'] ??
    []) as string[];

  const user = authStore.currentUser();

  if (!user?.privileges?.length) {
    return router.createUrlTree(['/login']);
  }

  const userPrivileges = new Set(user.privileges.map((p) => p.actionCode));

  const hasAllPrivileges = expectedPrivileges.every((priv) =>
    userPrivileges.has(priv),
  );

  if (!hasAllPrivileges) {
    return router.createUrlTree(['']);
  }

  return true;
};
